import { render, staticRenderFns } from "./ConfirmationDelete.vue?vue&type=template&id=65876077&scoped=true"
import script from "./ConfirmationDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmationDelete.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationDelete.vue?vue&type=style&index=0&id=65876077&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65876077",
  null
  
)

export default component.exports